/**
 * 小游戏页左上角的"回书院"—— 用普通链接而不是 useNavigate,
 * 这样页面在没有 Router 包裹时(单独测试、直接打开网址)也能用
 */
function BackToMap() {
  return (
    <a href="/map" data-testid="back-to-map" className="self-start text-sm font-medium text-gray-500 underline">
      ← 六艺书院
    </a>
  );
}

export default BackToMap;
